import { Controller } from 'stimulus';
import throttle from '../helpers/throttle';

const $window = $(window);

const STUCK_CLASS = 'is-stuck';
const ACTIVE_CLASS = 'is-active';
const SHOW_OFFSET = 300;

/**
 * Button to return to the top of the page
 *
 * @class ToTop
 * @extends {Controller}
 */
class ToTop extends Controller {
  connect() {
    this.onResize();
    this.throttledScroll = throttle(this.checkVisibility.bind(this), 150);
  }

  onScroll() {
    this.throttledScroll();
  }

  checkVisibility() {
    // Get the current scroll position
    const top = $window.scrollTop();

    // Check if we hit the footer
    const isHit = (top + this.windowHeight) > this.footerOffset;

    // Check if the element should be visibile
    const isVisible = (top > SHOW_OFFSET);

    // Add classes for making it stick to the footer
    if (isHit && !$(this.element).hasClass(STUCK_CLASS)) {
      $(this.element).addClass(STUCK_CLASS);
    } else if (!isHit && $(this.element).hasClass(STUCK_CLASS)) {
      $(this.element).removeClass(STUCK_CLASS);
    }

    // Add classes to make the button visible
    if (isVisible && !$(this.element).hasClass(ACTIVE_CLASS)) {
      $(this.element).addClass(ACTIVE_CLASS);
    } else if (!isVisible && $(this.element).hasClass(ACTIVE_CLASS)) {
      $(this.element).removeClass(ACTIVE_CLASS);
    }
  }

  onResize() {
    this.windowHeight = $window.height();
    this.footerOffset = $('.footer').offset().top;
  }
}

ToTop.targets = [
  //
];

export default ToTop;
